import React from "react"

import { ZoomScrollButton } from "./index"

export default function PerGraphZoomScrollButtons({
  axesAndRanges = {},
  intl,
  zoomRanges = {},
  zoomConfig,
  extraStyle = {},
}) {
  return (
    <div style={{ display: "flex", padding: "5px", ...extraStyle }}>
      {axesAndRanges["time"] && (
        <div>
          <ZoomScrollButton intl={intl} label={"<"} zoomRanges={zoomRanges} zoomConfig={zoomConfig} />
        </div>
      )}
      {axesAndRanges["time"] && (
        <div style={{ marginLeft: "auto" }}>
          <ZoomScrollButton intl={intl} label={">"} zoomRanges={zoomRanges} zoomConfig={zoomConfig} />
        </div>
      )}
    </div>
  )
}
